"use client";
import axios from "axios";

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: 10000,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    Authorization: process.env.NEXT_PUBLIC_STRAPI_KEY,
  },
});

// Add response interceptor for error handling
instance.interceptors.response.use(
  (response) => {
    return response;

  },
  (error) => {
    if (process.env.NODE_ENV === "development") {
      const status = error.response?.status;
      const statusText = error.response?.statusText;
      const requestUrl = error.config?.url;
      const method = error.config?.method?.toUpperCase();
      const responseData = error.response?.data;

      console.error("API Error:", status, statusText);
      console.error("Request:", method, requestUrl);
      console.error("Response Data:", responseData);
    }
    return Promise.reject(error);
  }
);

export default instance;
